import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-item-letter',
  templateUrl: './product-item-letter.component.html',
  styleUrls: ['./product-item-letter.component.css']
})
export class ProductItemLetterComponent implements OnInit {

  @Input()
  product:any;

  public urlHost = "";
  constructor() {
    this.urlHost = environment.urlHostImage;
   }

  ngOnInit() {
  }

}
